/**
 * 로그인 후 이동할 경로를 정의한다.
 * @version 1.0.0
 * @created 2026-02-07
 */

/** 로그인 후 이동을 허용하는 경로. */
export const ALLOWED_REDIRECT_ROUTES = [
  // Home
  "/",

  // Product
  "/product/list",

  // Orders
  "/reservation/daily",
  "/order/list",
  "/order/cancel",
  "/order/product",
  "/order/unpayment",

  // Customers
  "/customer/agreement",
  "/customer/alerts",
  "/customer/certificate",

  // Employees
  "/employee/attendance",
  "/attendance/history",
  "/attendance/leave",

  // Fund management
  "/fund/account",
  "/fund/cash",
  "/fund/refund",

  // Admin
  "/admin/invitations",

  // Console
  "/console/allowlist",

  // Profile
  "/profile",
  "/profile/sessions",
  "/profile/attendance",
] as const;

/**
 * 허용된 이동 경로인지 확인한다.
 * @param path Redirect path, with optional query.
 * @returns Whether the path is allowed.
 */
export function isAllowedRedirectRoute(path: string): boolean {
  // Remove the query string.
  const pathname = path.split("?")[0];

  // Check exact routes first.
  if (ALLOWED_REDIRECT_ROUTES.includes(pathname as any)) {
    return true;
  }

  // Check dynamic routes.
  for (const route of ALLOWED_REDIRECT_ROUTES) {
    if (route.includes(":")) {
      // Match one path segment per parameter.
      const pattern = route.replace(/:[^/]+/g, "[^/]+");
      const regex = new RegExp(`^${pattern}$`);

      if (regex.test(pathname)) {
        return true;
      }
    }
  }

  return false;
}
